export default [
  // ===== Wilayah =====
  {
    path: "/master-wilayah/",
    component: () => import("@/pages/master-data/wilayah/wilayah-list.vue"),
    meta: { title: "Master Wilayah" },
  },
  {
    path: "/master-wilayah/create",
    component: () => import("@/pages/master-data/wilayah/wilayah-form.vue"),
    meta: { title: "Tambah Wilayah" },
  },
  {
    path: "/master-wilayah/update/:id",
    component: () => import("@/pages/master-data/wilayah/wilayah-form.vue"),
    meta: { title: "Edit Wilayah" },
  },

  // ===== Penyakit =====
  {
    path: "/master-penyakit/",
    component: () =>
      import("@/pages/master-data/penyakit-ternak/penyakit-ternak-list.vue"),
    meta: { title: "Daftar Penyakit Ternak" },
  },
  {
    path: "/master-penyakit/create",
    component: () =>
      import("@/pages/master-data/penyakit-ternak/penyakit-ternak-form.vue"),
    meta: { title: "Tambah Penyakit Ternak" },
  },
  {
    path: "/master-penyakit/update/:id",
    component: () =>
      import("@/pages/master-data/penyakit-ternak/penyakit-ternak-update.vue"),
    meta: { title: "Edit Penyakit Ternak" },
  },

  // ===== Jenis Ternak =====
  {
    path: "/master-jenis-ternak/",
    component: () =>
      import("@/pages/master-data/jenis-ternak/jenis-ternak-list.vue"),
    meta: { title: "Daftar Jenis Ternak" },
  },
  {
    path: "/master-jenis-ternak/create",
    component: () =>
      import("@/pages/master-data/jenis-ternak/jenis-ternak-form.vue"),
    meta: { title: "Tambah Jenis Ternak" },
  },
  {
    path: "/master-jenis-ternak/update/:id",
    component: () =>
      import("@/pages/master-data/jenis-ternak/jenis-ternak-update.vue"),
    meta: { title: "Edit Jenis Ternak" },
  },

  // ===== Kelompok Tani =====
  {
    path: "/master-kelompok-tani/",
    component: () =>
      import("@/pages/master-data/kelompok-tani/master-kelompok-tani-list.vue"),
    meta: { title: "Daftar Kelompok Tani" },
  },
  {
    path: "/master-kelompok-tani/create",
    component: () =>
      import("@/pages/master-data/kelompok-tani/master-kelompok-tani-form.vue"),
    meta: { title: "Tambah Kelompok Tani" },
  },
  {
    path: "/master-kelompok-tani/update/:id",
    component: () =>
      import(
        "@/pages/master-data/kelompok-tani/master-kelompok-tani-update.vue"
      ),
    meta: { title: "Edit Kelompok Tani" },
  },
  {
    path: "/master-kelompok-tani/detail/:id",
    component: () =>
      import(
        "@/pages/master-data/kelompok-tani/master-kelompok-tani-detail.vue"
      ),
    meta: { title: "Detail Kelompok Tani" },
  },

  // ===== Anggota Kelompok =====
  {
    path: "/master-anggota-kelompok-tani/",
    component: () =>
      import(
        "@/pages/master-data/anggota-kelompok-tani/master-anggota-kelompok-tani-list.vue"
      ),
    meta: { title: "Daftar Anggota Kelompok" },
  },
  {
    path: "/master-anggota-kelompok-tani/create",
    component: () =>
      import(
        "@/pages/master-data/anggota-kelompok-tani/master-anggota-kelompok-tani-form.vue"
      ),
    meta: { title: "Tambah Anggota Kelompok" },
  },
  {
    path: "/master-anggota-kelompok-tani/update/:id",
    component: () =>
      import(
        "@/pages/master-data/anggota-kelompok-tani/master-anggota-kelompok-tani-update.vue"
      ),
    meta: { title: "Edit Anggota Kelompok" },
  },
  {
    path: "/master-anggota-kelompok-tani/detail/:id",
    component: () =>
      import(
        "@/pages/master-data/anggota-kelompok-tani/master-anggota-kelompok-tani-detail.vue"
      ),
    meta: { title: "Detail Anggota Kelompok" },
  },

  // ===== Kelompok Ternak =====
  {
    path: "/master-kelompok-ternak/",
    component: () =>
      import(
        "@/pages/master-data/kelompok-ternak/master-kelompok-ternak-list.vue"
      ),
    meta: { title: "Daftar Kelompok Ternak" },
  },
  {
    path: "/master-kelompok-ternak/create",
    component: () =>
      import(
        "@/pages/master-data/kelompok-ternak/master-kelompok-ternak-form.vue"
      ),
    meta: { title: "Tambah Kelompok Ternak" },
  },
  {
    path: "/master-kelompok-ternak/update/:id",
    component: () =>
      import(
        "@/pages/master-data/kelompok-ternak/master-kelompok-ternak-update.vue"
      ),
    meta: { title: "Edit Kelompok Ternak" },
  },
  {
    path: "/master-kelompok-ternak/detail/:id",
    component: () =>
      import(
        "@/pages/master-data/kelompok-ternak/master-kelompok-ternak-detail.vue"
      ),
    meta: { title: "Detail Kelompok Ternak" },
  },

  // ===== Anggota Kelompok =====
  {
    path: "/master-anggota-kelompok-ternak/",
    component: () =>
      import(
        "@/pages/master-data/anggota-kelompok-ternak/master-anggota-kelompok-ternak-list.vue"
      ),
    meta: { title: "Daftar Anggota Kelompok" },
  },
  {
    path: "/master-anggota-kelompok-ternak/create",
    component: () =>
      import(
        "@/pages/master-data/anggota-kelompok-ternak/master-anggota-kelompok-ternak-form.vue"
      ),
    meta: { title: "Tambah Anggota Kelompok" },
  },
  {
    path: "/master-anggota-kelompok-ternak/update/:id",
    component: () =>
      import(
        "@/pages/master-data/anggota-kelompok-ternak/master-anggota-kelompok-ternak-update.vue"
      ),
    meta: { title: "Edit Anggota Kelompok" },
  },
  {
    path: "/master-anggota-kelompok-ternak/detail/:id",
    component: () =>
      import(
        "@/pages/master-data/anggota-kelompok-ternak/master-anggota-kelompok-ternak-detail.vue"
      ),
    meta: { title: "Detail Anggota Kelompok" },
  },
];
